import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Autocomplete,
  TextField
} from "@mui/material";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import swal from "sweetalert2";
import { api } from "utils/Api";
import { useHierarchy } from "context/HierarchyContext";
import { showError } from "utils/messageAlerts";
import { showWarning } from "utils/messageAlerts";
import { showSuccess } from "utils/messageAlerts";

function ManagerAddPropertyPopup({ onClose, refreshData }) {
  const [loading, setLoading] = useState(false);
  const [assignedUserEmail, setAssignedUserEmail] = useState("");
  const [properties, setProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const { orgId } = useHierarchy();

  useEffect(() => {
    fetchProperties();
  }, []);

  const fetchProperties = async () => {
    try {
      const response = await api.su_Property.getSuProperties(); // change API name as per your project
      const propertyData = response.filter(property => property.organization_id === parseInt(orgId));
      setProperties(propertyData || []);
    } catch (e) {
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedProperty) {
      showWarning("Please select a property");
      return;
    }

    if (!assignedUserEmail) {
      showWarning("Please enter user email");
      return;
    }

    setLoading(true);

    try {
      await api.su_Property.postUserToProperty({
        user_email: assignedUserEmail,
        property_id: selectedProperty.id,
        organization_id: selectedProperty.organization_id,
        user_role_id: 3,
        frontend_metadata: {},
        backend_metadata: {},
      });

      showSuccess("Manager added to property successfully");

      onClose();
      refreshData();
    } catch (error) {
  
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Add User to Property</DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Searchable Property */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                Select Property <Box component="span" color="error.main">*</Box>
              </SoftTypography>

              <Autocomplete
                options={properties}
                getOptionLabel={(option) => option.name || ""}
                value={selectedProperty}
                onChange={(event, newValue) => setSelectedProperty(newValue)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search property..."
                    size="small"
                  />
                )}
              />
            </SoftBox>

            {/* User Email */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                User Email <Box component="span" color="error.main">*</Box>
              </SoftTypography>

              <SoftInput
                type="email"
                placeholder="Enter user email to assign as MANAGER"
                value={assignedUserEmail}
                onChange={(e) => setAssignedUserEmail(e.target.value)}
                required
              />
            </SoftBox>

          </Box>
        </DialogContent>

        <DialogActions>
          <SoftButton onClick={onClose}>Cancel</SoftButton>
          <SoftButton
            variant="gradient"
            color="dark"
            disabled={loading}
            type="submit"
          >
            {loading ? "Saving..." : "Save"}
          </SoftButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

ManagerAddPropertyPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  refreshData: PropTypes.func.isRequired,
};

export default ManagerAddPropertyPopup;